import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Calculator from "@/pages/Calculator";
import QuoteHistory from "@/pages/QuoteHistory";
import QuoteDetail from "@/pages/QuoteDetail";
import Settings from "@/pages/Settings";
import PublicQuote from "@/pages/PublicQuote";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          {/* Public client-facing route — no admin layout */}
          <Route path="/q/:token" element={<PublicQuote />} />

          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/calculator" element={<Calculator />} />
            <Route path="/quotes" element={<QuoteHistory />} />
            <Route path="/quotes/:id" element={<QuoteDetail />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
